<template>
  <div class="vx-card">
    <form class="p-4 mb-5 card-bg" @submit.prevent="getSubscriptionSystem()">
      <h1 class="p-4 text-center mb-5">Abonelik Yönetimi</h1>

      <div id="satis-islemleri " class="">
        <!--Arama 1.row-->
        <div class="id-inputs vx-row">
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Aktivasyon Form Id</b></label>
            <vs-input type="number" size="large" class="w-full" v-model="subscriptionSearch.activationFormId" />
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Satış Id</b></label>
            <vs-input type="number" size="large" class="w-full" v-model="subscriptionSearch.saleOrderId" />
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Müşteri Id</b></label>
            <vs-input type="number" size="large" class="w-full" v-model="subscriptionSearch.customerId" />
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Personel</b></label>
            <v-select @input="getSubscriptionSystem()" name="Id" v-model="subscriptionSearch.userId" placeholder="Kullanıcı Seçiniz" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-2/3 w-full">
                <label class="text-sm"><b>Ürün</b></label>
                <vs-input type="number" class="w-full" size="large" v-model="subscriptionSearch.productId" />
              </div>
              <div class="vx-col mt-5">
                <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
              </div>
            </div>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Aktivasyon Kalan Gün</b></label>
            <v-select @input="getSubscriptionSystem()" name="Id" v-model="subscriptionSearch.remainDay" placeholder="Seçiniz" :options="remainDayList" label="remainDay" class="w-full" :reduce="(row) => row.remainDay">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
        </div>
        <!--Arama 2.row-->
        <div class="id-inputs vx-row">
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Marka</b></label>
            <v-select @input="getSubscriptionSystem()" name="brand" placeholder="Seçiniz" v-model="subscriptionSearch.brand" :options="productBrandList" :clearable="true" :reduce="(productBrandList) => productBrandList.brandName" label="brandName">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Başlangıç</b></label>
            <vs-input type="date" size="medium" class="w-full" v-model="subscriptionSearch.renewalStartDate" />
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Bitiş</b></label>
            <vs-input @change="getSubscriptionSystem()" type="date" size="medium" class="w-full" v-model="subscriptionSearch.renewalFinishDate" />
          </div>

          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Seri No 1</b></label>
            <vs-input type="text" size="large" class="w-full" v-model="subscriptionSearch.serialCode1" />
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Seri No 2</b></label>
            <vs-input type="text" size="large" class="w-full" v-model="subscriptionSearch.serialCode2" />
          </div>
        </div>
        <!---->

        <div class="id-inputs vx-row mt-5">
          <div class="vx-col mb-4 islem-id md:w-1/6 w-full">
            <div style="cursor: pointer; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <b> {{ "Toplam Maaliyet : " }}{{ getSumOfOwningCost(subscriptionList) }} {{ " TL " }}</b>
            </div>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full flex justify-center">
            <div v-if="subscriptionListAll == null" @click="getAllSubscription()" style="cursor: pointer; width: 165px; margin-bottom: -35px; margin-top: 20px;" class="mt-2 px-4 py-1 flex items-center">
              <feather-icon v-if="subscriptionListAll == null" svgClasses="w-6 h-6" icon="FileTextIcon" class="mr-2" />
              <b>Tüm Abonelikleri Oluştur</b>
            </div>
            <div v-if="subscriptionListAll" style="cursor: pointer; width: 100px; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="subscriptionListAll" class><b>Tüm Abonelikler</b></JsonExcel>
            </div>
          </div>
        </div>
        <div class="id-inputs vx-row mt-5">
          <div class="vx-col mb-4 islem-id md:w-1/6 w-full">
            <div style="cursor: pointer; margin-bottom: -35px; margin-top: 20px;" class="px-4 py-1 flex items-center">
              <b>{{ "Toplam Satış : " }} {{ getSumOfSalePrice(subscriptionList) }} {{ " TL " }}</b>
            </div>
          </div>
        </div>

        <div class="satis-buton w-full tFlex tFlex_column tFlex_ai-c" style="margin-top: -50px;">
          <vs-button class="vx-col md:w-1/4 w-full mb-4" style=""> Detaylı Ara</vs-button>
          <p class="text-center md:w-1/4 mb-4"></p>
          <vs-button class="vx-col md:w-1/4 w-full" @click="subscriptionPopup = true">Abonelik Ekle</vs-button>
        </div>
      </div>
    </form>

    <ag-grid-vue
      style="height: 45vh;"
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="subscriptionList"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :rowClassRules="rowClassRules"
      :context="context"
    ></ag-grid-vue>

    <vs-pagination :total="totalPages" :max="10" v-model="currentPage" />

    <vs-prompt
      :vs-title="subscriptionItem.activationFormId ? 'Abonelik Güncelle # ' + subscriptionItem.activationFormId + ' # ' + subscriptionItem.productName : 'Abonelik Ekle'"
      vs-button-cancel="border"
      vs-cancel-text="İptal"
      vs-accept-text="Kaydet"
      @vs-accept="saveSubscription()"
      @vs-close="cancel"
      @vs-cancel="cancel"
      vs-color="warning"
      :vs-active.sync="subscriptionPopup"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2">
          <div>
            <label><b>Satış Id</b></label>
            <template v-if="subscriptionItem.activationFormId">
              <a :href="'/SaleByOrderId/' + subscriptionItem.saleOrderId" target="_blank"><vs-input :disabled="true" type="number" v-model="subscriptionItem.saleOrderId" class="w-full" name="saleOrderId" /></a>
            </template>
            <template v-else>
              <vs-input type="number" v-model="subscriptionItem.saleOrderId" class="w-full" name="saleOrderId" />
            </template>
          </div>

          <div class="mt-5">
            <label><b>Satış Detay Id</b></label>
            <template v-if="subscriptionItem.activationFormId">
              <vs-input :disabled="true" type="number" v-model="subscriptionItem.saleOrderLineId" class="w-full" name="saleOrderLineId" />
            </template>
            <template v-else>
              <vs-input type="number" v-model="subscriptionItem.saleOrderLineId" class="w-full" name="saleOrderLineId" />
            </template>
          </div>
          <div class="mt-5">
            <label><b>* Oluşturma Tarihi</b></label>
            <vs-input type="date" v-model="subscriptionItem.date" class="w-full" name="date" />
          </div>
          <div class="mt-5">
            <div class="vx-row justify-between flex mt-2" v-if="!subscriptionItem.activationFormId">
              <div class="vx-col justify-end flex md:w-1/3 small-icon">
                <vs-button color="success" type="filled" @click="addNewCustomer">Müşteri Ekle</vs-button>
              </div>
              <div class="vx-col md:w-1/3 flex small-icon">
                <vs-input icon-pack="feather" icon="icon-user" class="w-full" placeholder="Müşteri Ara" v-model="searchQuery" @keyup="delayedSearch" />
              </div>
              <div class="vx-col md:w-1/3 flex small-icon">
                <vs-button type="border" class="ml-5" @click="search">Ara</vs-button>
              </div>
              <add-new-customer :addnew="addNewCust" :withAdditionalData="true" v-if="addNewCust" @hideAddNewRegister="hideAddNewCust"></add-new-customer>
              <div class="vx-row mt-5 ml-0 w-full">
                <div class="vx-col w-full">
                  <vs-table noDataText="Tabloda Veri Yok" :data="customerSearch">
                    <template slot="thead">
                      <vs-th hidden>id</vs-th>
                      <vs-th class="md:w-1/3">Müşteri</vs-th>
                      <vs-th class="md:w-1/6">Seç</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="data[i].userId" v-for="(tr, i) in data" class="pt-0 pb-1" :state="tr.span ? 'danger' : ''" :title="tr.span ? 'Kendisiyle iletişim kurulmasını istemiyor!' : ''">
                        <vs-td hidden :data="data[i].userId" class="pt-0 pb-1">{{ data[i].userId }}</vs-td>
                        <vs-td :data="tr.firstName + ' ' + (tr.lastName || '')" class="pt-0 pb-1">{{ tr.firstName + " " + (tr.lastName || "") }}<b v-if="tr.span"> Kendisiyle iletişim kurulmasını istemiyor</b></vs-td>
                        <td class="flex">
                          <vs-radio icon="CheckSquareIcon" v-model="selectedCustomerRadio" :vs-value="i" @change="selectItem(i)" />
                          <feather-icon title="Müşteri Bilgileri" icon="InfoIcon" svgClasses="h-10 w-10 text-success hover:text-primary cursor-pointer p-2 ml-5" @click="$router.push('/contactsView/' + tr.customerId).catch((err) => {})" />
                        </td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
            <label><b>* Müşteri</b></label>
            <template v-if="subscriptionItem.activationFormId">
              <a :href="'/contactsView/' + subscriptionItem.customerId" target="_blank"><vs-input :disabled="true" type="number" v-model="subscriptionItem.customerId" class="w-full" name="customerId" /></a>
            </template>
            <template v-else>
              <vs-input type="number" v-model="subscriptionItem.customerId" class="w-full" name="customerId" />
            </template>
          </div>
          <div class="mt-5">
            <label><b>* Personel</b></label>
            <template v-if="subscriptionItem.activationFormId">
              <v-select :disabled="true" name="Id" v-model="subscriptionItem.userId" placeholder="Kullanıcı Seçiniz" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </template>
            <template v-else>
              <v-select name="Id" v-model="subscriptionItem.userId" placeholder="Kullanıcı Seçiniz" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </template>
          </div>

          <div class="mt-5">
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <label class="text-sm"><b>* Ürün</b></label>
                <vs-input type="number" class="w-full" size="medium" v-model="subscriptionItem.productId" />
              </div>
              <div class="vx-col mt-5">
                <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
              </div>
            </div>
          </div>

          <div class="mt-5">
            <label><b>* Seri No 1</b></label>
            <vs-input type="text" v-model="subscriptionItem.serialCode1" class="w-full" name="serialCode1" />
          </div>
          <div class="mt-5">
            <label><b>Seri No 2</b></label>
            <vs-input type="text" v-model="subscriptionItem.serialCode2" class="w-full" name="serialCode2" />
          </div>
          <div class="mt-5">
            <label><b>* Lisans Başlangıç Tarihi</b></label>
            <vs-input type="date" v-model="subscriptionItem.startDate" class="w-full" name="startDate" />
          </div>
          <div class="mt-5">
            <label><b>* Son Yenileme Tarihi</b></label>
            <vs-input type="date" v-model="subscriptionItem.renewalDate" class="w-full" name="renewalDate" />
          </div>
        </div>
        <div class="vx-col md:w-1/2">
          <div class="">
            <label><b>Açıklama</b></label>
            <vs-textarea v-model="subscriptionItem.description" />
          </div>
          <div class="mt-5">
            <label><b>Mail Konusu</b></label>
            <vs-input type="text" v-model="subscriptionItem.mailSubject" class="w-full" name="mailSubject" />
          </div>
          <div class="mt-5">
            <label><b>Mail İçerik</b></label>
            <vs-input type="text" v-model="subscriptionItem.mailBody" class="w-full" name="mailBody" />
          </div>
          <div class="mt-5">
            <label><b>Email</b></label>
            <vs-input type="text" v-model="subscriptionItem.eMail" class="w-full" name="eMail" />
          </div>
          <div class="mt-5">
            <label><b>Master Mail</b></label>
            <vs-input type="text" v-model="subscriptionItem.masterMail" class="w-full" name="masterMail" />
          </div>
          <div class="mt-5">
            <label><b>Adres</b></label>
            <vs-input :disabled="true" type="text" v-model="subscriptionItem.address" class="w-full" name="address" />
          </div>
          <div class="mt-5">
            <label><b>* Telefon</b></label>
            <vs-input :disabled="true" type="text" v-model="subscriptionItem.phone" class="w-full" name="phone" />
          </div>
          <div class="mt-5">
            <label><b>* TCKN / VKN</b></label>
            <vs-input :disabled="true" type="text" v-model="subscriptionItem.taxNumber" class="w-full" name="taxNumber" />
          </div>
          <div class="mt-5">
            <label><b>* Lisans Süresi</b></label>
            <v-select name="Id" v-model="subscriptionItem.licencePeriod" :options="licencePeriodList" label="licencePeriod" class="w-full" :reduce="(row) => row.licencePeriod">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="mt-5">
            <label><b>* Satın Alma Id</b></label>
            <template v-if="subscriptionItem.activationFormId">
              <a :href="'/Purchase/' + subscriptionItem.purchaseId" target="_blank"><vs-input :disabled="true" type="number" v-model="subscriptionItem.purchaseId" class="w-full" name="purchaseId" /></a>
            </template>
            <template v-else>
              <vs-input type="number" v-model="subscriptionItem.purchaseId" class="w-full" name="purchaseId" />
            </template>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import addNewCustomer from "../contacts/addNewPrompt.vue";
import ProductSearch from "../Search/ProductSearch.vue";
import JsonExcel from "vue-json-excel";

import CellRendererDetail from "./CellRenderer/CellRendererDetail.vue";
import CellRendererActions from "./CellRenderer/CellRendererActions.vue";
export default {
  components: {
    vSelect,
    AgGridVue,
    CellRendererDetail,
    CellRendererActions,
    addNewCustomer,
    ProductSearch,
    JsonExcel,
  },
  data() {
    return {
      subscriptionList: [],
      customerSearch: [],
      userList: [],
      productBrandList: [],
      remainDayList: [{ remainDay: 7 }, { remainDay: 15 }, { remainDay: 30 }, { remainDay: 45 }, { remainDay: 60 }, { remainDay: 75 }, { remainDay: 90 }],
      licencePeriodList: [{ licencePeriod: 1 }, { licencePeriod: 2 }, { licencePeriod: 3 }, { licencePeriod: 4 }, { licencePeriod: 5 }, { licencePeriod: 6 }],
      brandSearch: { brandName: null },

      subscriptionSearch: {
        activationFormId: null,
        saleOrderId: null,
        customerId: null,
        userId: null,
        productId: null,
        phone: null,
        remainDay: null,
        brand: null,
        renewalStartDate: null,
        renewalFinishDate: null,
        serialCode1: null,
        serialCode2: null,
      },
      subscriptionItem: {
        activationFormId: null,
        saleOrderId: null,
        saleOrderLineId: null,
        date: null,
        customerId: null,
        userId: null,
        productId: null,
        productName: null,
        serialCode1: null,
        serialCode2: null,
        description: null,
        mailSubject: null,
        mailBody: null,
        eMail: null,
        masterEmail: null,
        address: null,
        phone: null,
        taxNumber: null,
        licencePeriod: null,
        purchaseId: null,
        operation: null,
        licenceFinishDate: null,
        remainDay: null,
        startDate: null,
        renewalDate: null,
      },
      subscriptionListAll: null,
      productSearchPopupParent: false,
      selectedCustomerRadio: {}.empty,
      subscriptionPopup: false,
      searchQuery: "",
      delayedSearchTimer: "",
      addNewCust: false,
      gridApi: null,
      rowClassRules: null,
      gridOptions: { rowHeight: 150 },
      context: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Aktivasyon Form Id",
          field: "activationFormId",
          filter: true,
          width: 100,
        },
        {
          headerName: "Satış Id",
          field: "saleOrderId",
          filter: true,
          width: 100,
        },
        {
          headerName: "Satış Detay Id",
          field: "saleOrderLineId",
          filter: true,
          width: 100,
        },

        {
          headerName: "Başlangıç",
          field: "startDate",
          filter: true,
          width: 100,
        },
        {
          headerName: "Yenileme",
          field: "renewalDate",
          filter: true,
          width: 100,
        },
        {
          headerName: "Bitiş",
          field: "licenceFinishDate",
          filter: true,
          width: 100,
        },
        {
          headerName: "Kalan Gün",
          field: "remainDay",
          filter: true,
          width: 100,
        },
        {
          headerName: "Detaylar",
          field: "detail",
          filter: true,
          editable: true,
          width: 400,
          cellRendererFramework: "CellRendererDetail",
        },

        {
          headerName: "Lisans Süresi",
          field: "licencePeriod",
          filter: true,
          width: 100,
        },
        {
          headerName: "Satınalma Id",
          field: "purchaseId",
          filter: true,
          width: 100,
        },
        {
          headerName: "İşlem",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
        },
      ],
    };
  },

  watch: {},
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.subscriptionItem.productId = v.productId;
        this.subscriptionItem.productName = v.productName;
        this.subscriptionSearch.productId = v.productId;
      } else {
        this.subscriptionItem.productId = null;
        this.subscriptionSearch.productId = null;
      }
    },
    getProductBrand: async function () {
      this.productBrandList = await repository.postEntity("Product/GetProductBrand", this.brandSearch).then((r) => r.list);
    },
    addNewCustomer() {
      this.addNewCust = true;
    },
    addNewCustomer() {
      this.addNewCust = true;
    },
    hideAddNewCust() {
      this.addNewCust = false;
    },
    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if (this.searchQuery && this.searchQuery.length > 3) this.search();
      }, 500);
    },
    selectItem(i) {
      if (!this.customerSearch[i].isReadyForInvoice) {
        if (!this.customerSearch[i].isOnlineCustomer) {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: this.customerSearch[i].error,
          });
          return;
        }
      }
      this.selectedCustomer = JSON.parse(JSON.stringify(this.customerSearch[i]));
      if (this.selectedCustomer.lastName != null) this.subscriptionItem.customerName = this.selectedCustomer.firstName + " " + this.selectedCustomer.lastName;
      else {
        this.subscriptionItem.customerName = this.selectedCustomer.firstName;
      }
      this.subscriptionItem.customerId = this.selectedCustomer.customerId;
      this.subscriptionItem.address = this.selectedCustomer.address;
      this.subscriptionItem.phone = this.selectedCustomer.phone;
      this.subscriptionItem.taxNumber = this.selectedCustomer.taxNumber;
    },
    search: async function () {
      this.customerSearch = await repository.getWithParam("Customer/search", "searchQuery=" + this.searchQuery).then((r) => r.list);
      if (this.customerSearch && this.customerSearch.length == 1) this.selectItem(0);
      for (let i = 0; i < this.customerSearch.length; i++) {
        let c = this.customerSearch[i];
        let span = c.firstName.indexOf("</span>");
        if (span > 0) {
          c.firstName = c.firstName.substr(span + 7).trim();
          c.span = true;
        }
      }
      return this.customerSearch;
    },
    saveSubscription: async function () {
      if (this.subscriptionItem.activationFormId) {
        this.subscriptionItem.operation = "Update";
      } else {
        this.subscriptionItem.operation = "Insert";
      }
      let result = await this.$swal.fire({
        icon: "warning",
        text: "Devam etmek istediğinize emin misiniz?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (result.isConfirmed) {
        this.$vs.loading();
        await repository.postEntity("Subscription/SaveSubscription", this.subscriptionItem);
        this.$vs.loading.close();
        await this.$swal.fire({ icon: "success", title: "Activasyon formu kaydedilmiştir." });
        this.getSubscriptionSystem();
      }
    },
    getSubscriptionSystem: async function () {
      this.subscriptionList = await repository.postEntity("Subscription/GetSubscriptionSystem", this.subscriptionSearch).then((r) => r.list);
      for (let i = 0; i < this.subscriptionList.length; i++) {
        if (this.subscriptionList[i].date) this.subscriptionList[i].date = this.subscriptionList[i].date.split("T")[0];
        if (this.subscriptionList[i].startDate) this.subscriptionList[i].startDate = this.subscriptionList[i].startDate.split("T")[0];
        if (this.subscriptionList[i].licenceFinishDate) this.subscriptionList[i].licenceFinishDate = this.subscriptionList[i].licenceFinishDate.split("T")[0];
        if (this.subscriptionList[i].renewalDate) this.subscriptionList[i].renewalDate = this.subscriptionList[i].renewalDate.split("T")[0];
        if (this.subscriptionList[i].renewalFinishDate) this.subscriptionList[i].renewalFinishDate = this.subscriptionList[i].renewalFinishDate.split("T")[0];
        if (this.subscriptionList[i].renewalStartDate) this.subscriptionList[i].renewalStartDate = this.subscriptionList[i].renewalStartDate.split("T")[0];
      }
    },
    getAllSubscription: async function () {
      this.$vs.loading();
      this.subscriptionListAll = await repository.postEntity("Subscription/GetAllSubscription", {}).then((r) => r.list);
      console.log("dd", this.subscriptionListAll);
      this.$vs.loading.close();
    },
    getSumOfOwningCost: function (list) {
      let totalOwningCostTl = 0.0;

      list.forEach((element) => {
        totalOwningCostTl += element.owningCostTl;
      });

      return totalOwningCostTl.toFixed(2);
    },
    getSumOfSalePrice: function (list) {
      let totalSalePriceTl = 0.0;

      list.forEach((element) => {
        totalSalePriceTl += element.salePriceTl;
      });

      return totalSalePriceTl.toFixed(2);
    },

    getUsers: async function () {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },
    cancel() {
      this.subscriptionItem = {};
    },
    close() {},
  },

  created: async function () {
    if (this.$route.params != null && this.$route.name == "SubscriptionByCustomerId" && this.$route.params.customerId > 0) this.subscriptionSearch.customerId = this.$route.params.customerId;
    this.$vs.loading();

    await Promise.all([this.getSubscriptionSystem(), this.getUsers(), this.getProductBrand()]);

    this.$vs.loading.close();
  },
  beforeMount() {
    this.rowClassRules = {};
    this.context = { componentParent: this };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();

    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.subscriptionPopup) this.subscriptionPopup = false;
        this.subscriptionItem = {};
      }
    });
  },
};
</script>
